import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation reportGroupPost($groupPostId: String!, $reason: String!) {
    reportGroupPost(groupPostId: $groupPostId, reason: $reason) {
      success
      message
    }
  }
`

export interface ReportPostInput {
  groupPostId: string
  reason: string
}

export interface ReportPostOutput {
  reportGroupPost: {
    success: boolean
    message: string
  }
}

export const useReportGroupPost = () => useMutation<ReportPostOutput, ReportPostInput>(mutation)
